import { filledInputClasses } from '@mui/material/FilledInput';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';

import { flagIconClasses } from '@components/FlagIcon';

export const flagIconBaseSx = { width: 22, height: 22, borderRadius: '50%' };

export const flagIconSmallSx = { width: 16, height: 16, borderRadius: '50%' };

export const flagIconSx = {
  ...flagIconBaseSx,
  mr: 1,
};
export const textFieldSx = (hiddenLabel?: boolean) => ({
  [`& .${outlinedInputClasses.root}`]: {
    [`& .${flagIconClasses.root}`]: { ml: 0.5, mr: -0.5 },
  },
  [`& .${filledInputClasses.root}`]: {
    [`& .${flagIconClasses.root}`]: { ml: 0.5, mr: -0.5, mt: hiddenLabel ? 0 : -2 },
  },
});
